import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, Filler, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

interface Iprops {
  labels: any[]; // X 값
  datasets: any[]; // 데이터 ex. [{label: '', data: [], borderColor: '', backgoundColor: ''}]
  title: string; // 차트 제목
  showLegend: boolean; // 레전드 표기 여부
  tension?: number; // 라인 곡률 (0 = 직선, 1 = 곡선)
  pointRadius?: number; // 포인트 크기
  pointHoverRadius?: number; // 호버 시 포인트 크기
}

const LineChart = ({ labels, datasets, title, showLegend, tension = 0.3, pointRadius = 0, pointHoverRadius = 5 }: Iprops) => {
  // 데이터 설정
  const data = {
    labels,
    datasets,
  };

  // 옵션 설정
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    tension,

    elements: {
      point: {
        radius: pointRadius, // 기본 포인트 크기
        pointHoverRadius, // 호버했을때 포인트크기
        hitRadius: 20, // 호버영역크기
      },
    },
    plugins: {
      legend: {
        display: showLegend,
        position: 'bottom' as const,
      },
      title: {
        display: true,
        text: title,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        border: {
          color: 'rgba(200, 200, 200, 0.4)', // x축 축선(가장 아래 라인) 색상
          width: 1,
        },
      },
      y: {
        min: 0, // Y축 최소값을 0으로 설정하여 음수 표시 방지
        grid: {
          color: 'rgba(227, 227, 227, 0.2)',
        },
        border: {
          color: 'rgba(200, 200, 200, 0.4)', // y축 축선(가장 왼쪽 라인) 색상
          width: 1,
        },
      },
    },
  };

  return <Line data={data} options={options} />;
};

export default LineChart;
